var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapMarkerOrange(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 59,
    viewBox: "0 0 40 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/location-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.3666 14.4997C32.6332 6.78301 25.8999 3.33301 19.9999 3.33301C19.9999 3.33301 19.9999 3.33301 19.9832 3.33301C14.0999 3.33301 7.38322 6.78301 5.63322 14.483C3.66656 23.083 8.93322 30.3663 13.6999 34.9663C15.4666 36.6663 17.7332 37.5163 19.9999 37.5163C22.2666 37.5163 24.5332 36.6663 26.2832 34.9663C31.0499 30.3663 36.3166 23.0997 34.3666 14.4997ZM24.5832 19.583H21.2499V22.9163C21.2499 23.5997 20.6832 24.1663 19.9999 24.1663C19.3166 24.1663 18.7499 23.5997 18.7499 22.9163V19.583H15.4166C14.7332 19.583 14.1666 19.0163 14.1666 18.333C14.1666 17.6497 14.7332 17.083 15.4166 17.083H18.7499V13.7497C18.7499 13.0663 19.3166 12.4997 19.9999 12.4997C20.6832 12.4997 21.2499 13.0663 21.2499 13.7497V17.083H24.5832C25.2666 17.083 25.8332 17.6497 25.8332 18.333C25.8332 19.0163 25.2666 19.583 24.5832 19.583Z",
    fill: "#FF7D1F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 261",
    filter: "url(#filter0_d_2059_43752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 44C27.5 44.0642 27.477 44.2383 27.2061 44.5229C26.928 44.8152 26.4545 45.1467 25.7548 45.4577C24.359 46.078 22.3256 46.5 20 46.5C17.6744 46.5 15.641 46.078 14.2452 45.4577C13.5455 45.1467 13.072 44.8152 12.7939 44.5229C12.523 44.2383 12.5 44.0642 12.5 44C12.5 43.9358 12.523 43.7617 12.7939 43.4771C13.072 43.1848 13.5455 42.8533 14.2452 42.5423C15.641 41.922 17.6744 41.5 20 41.5C22.3256 41.5 24.359 41.922 25.7548 42.5423C26.4545 42.8533 26.928 43.1848 27.2061 43.4771C27.477 43.7617 27.5 43.9358 27.5 44Z",
    stroke: "#FF7D1F",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2059_43752",
    x: 0,
    y: 29,
    width: 40,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2059_43752"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2059_43752"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2059_43752",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerOrange);
export default __webpack_public_path__ + "static/media/map-marker-orange.5dce6803b7bdddf92dce7bcb26296b9f.svg";
export { ForwardRef as ReactComponent };